import React, {useEffect, useState} from "react";
import hatpicture from '../images/FullSizeRender.jpeg';
import toolpicture from '../images/stitchUp.png';
import prizespicture from '../images/prizes.png';

import {Anchor, Button, ConfigProvider, Image, List, Menu, Modal, Typography} from "antd";
import {MailOutlined, HeartFilled, HeartOutlined} from "@ant-design/icons";
import {FileService} from "../services/fileService";
const { Paragraph, Text } = Typography;

export default function HomePage() {
    const [modal, setModal] = useState(false);
    const [fileError, setFileError] = useState("");
    const [fileUrl, setFileUrl] = useState("");

    const handleOnClick = (item: any) => {
        if (item.key === "contact") {
            setModal(true);
        }
    }

    const handleCancel = () => {
        setModal(false);
    }

    useEffect(() => {
        const fileService = new FileService();
        fileService.downloadPattern()
            .then((url) => {
                if (url) {
                    setFileUrl(url);
                    setFileError("");
                } else {
                    setFileError("Issue downloading file. Please email kekerr@cs.ubc.ca for help. Sorry!");
                }
            }).catch(() => {
                setFileError("Issue downloading file. Please email kekerr@cs.ubc.ca for help. Sorry!");
            });
    }, []);

    return <>
        <h2 className="logo">StitchUp</h2>
        <Menu
            className="home-page-menu"
            selectedKeys={[]}
            theme="dark"
            mode="horizontal"
            onClick={(item) => handleOnClick(item)}
            items={[
                {
                    label: "Contact",
                    key: "contact",
                    icon: <MailOutlined/>
                }
            ]}
            style={{justifyContent: 'flex-end'}}/>
        <ConfigProvider
            theme={{
                token: {
                    colorPrimary: '#41B3A3',
                },
            }}
        >
            <div style={{ padding: '20px' }}>
                <Paragraph>
                    <Text italic>(Please scroll down to find information about the Study, Prizes and Pacific Crest Hat Pattern)</Text>
                </Paragraph>
                <Anchor
                    direction="horizontal"
                    items={[
                        {
                            key: 'study',
                            href: '#study',
                            title: 'Study',
                        },
                        {
                            key: 'prizes',
                            href: '#prizes',
                            title: 'Study Prizes',
                        },
                        {
                            key: 'tool',
                            href: '#tool',
                            title: 'StitchUp Tool',
                        },
                        {
                            key: 'pattern',
                            href: '#pattern',
                            title: 'Pacific Crest Hat Pattern',
                        }
                    ]}
                />
            </div>
            <div>
                <div
                    id="study"
                    style={{
                        width: '100vw',
                        height: '30vh',
                        textAlign: 'center',
                        background: 'white',
                    }}
                >
                    <h1>Knitting Study</h1>
                    <h2>Now Closed as of June 1st, 2023</h2>
                    <Paragraph>
                        <Text strong>Thank you so much for the support with my study! I could not be happier with the participation!
                        </Text>
                    </Paragraph>
                    <Paragraph>
                        <Text>I will be drawing for prizes on June 1st and emailing the winners on June 2nd. Best of luck!</Text>
                    </Paragraph>
                    <Button
                        style={{"color": "white"}}
                        type="primary"
                        size="large"
                        icon={<HeartOutlined/>}
                        disabled={true}
                        href="https://ubc.ca1.qualtrics.com/jfe/form/SV_5aJbVNvCqZLIINU"
                    >
                        (Closed) Start Study!
                    </Button>
                </div>
                <div
                    id="prizes"
                    style={{
                        width: '100vw',
                        height: '80vh',
                        textAlign: 'center',
                        background: 'rgba(65,179,163,0.1)',
                    }}
                >
                    <h1>Study Prizes</h1>
                    <Paragraph>
                        <Text strong>For participation in the study, you can enter a raffle for one of five knitting prizes!</Text>
                    </Paragraph>
                    <Paragraph>
                        All the prizes are made by Canadian makers and include two project bags, yarn and cute knitting accessories.
                    </Paragraph>
                    <Paragraph>
                        <Image
                            height="35vh"
                            width="50vh"
                            preview={false}
                            src={prizespicture}/>
                    </Paragraph>
                    <Paragraph>
                        <List>
                            <li>
                                1st Prize: <a target="_blank" href="https://misneach.ca/collections/harris-tweed-project-bags/products/autumnal-plaid-harris-tweed%C2%AE-project-bag">Autumnal Harris Tweed Project Bag by Misneach</a> ($150 CAD Value)
                            </li>
                            <li>
                                2nd Prize: <a target="_blank" href="https://misneach.ca/collections/harris-tweed-project-bags/products/moss-green-harris-tweed-project-bag">Moss Green Harris Tweed Project Bag by Misneach</a> ($150 CAD Value)
                            </li>
                            <li>
                                3rd Prize: <a target="_blank" href="https://sweetgeorgiayarns.com/shop/sock-kit-tough-love-sock-keswick/">Sock Kit by SweetGeorgiaYarns</a> ($48.50 CAD Value)
                            </li>
                            <li>
                                4th Prize: <a target="_blank" href="https://sweetgeorgiayarns.com/product-category/yarn/sweetgeorgia-yarns/superwash-worsted/?orderby=menu_order">Superwash Worsted by SweetGeorgia Yarns</a> ($36.50 CAD Value)
                            </li>
                            <li>
                                5th Prize: <a target="_blank" href="https://fireflynotesonline.com/products/seashell-stitch-markers-10-mm-snag-free-plus-one-removable-knitting-notions">Shell Stitch Markers by Firefly Notes</a> and <a target="_blank" href="https://www.foxandpinestitches.com/product/moose-stitch-stoppers/">Moose Stitch Stoppers by Fox & Pine</a> ($30 CAD Value)
                            </li>
                        </List>
                    </Paragraph>
                </div>
                <div
                    id="tool"
                    style={{
                        width: '100vw',
                        height: '80vh',
                        textAlign: 'center',
                        background: 'rgba(255,77,104,0.1)'
                    }}
                >
                    <h1>StitchUp Tool</h1>
                    <Paragraph>
                        In the study, you will use a knitting tool I created. Below is a screenshot of StitchUp.
                    </Paragraph>
                    <Paragraph>
                        <Image
                            height="40vh"
                            width="70vh"
                            preview={false}
                            src={toolpicture}/>
                    </Paragraph>
                </div>
                <div
                    id="pattern"
                    style={{
                        width: '100vw',
                        height: '100vh',
                        textAlign: 'center'
                    }}
                >
                    <h1>Pacific Crest Hat Pattern</h1>
                    <Paragraph>
                        I'm very excited to release my first pattern - the Pacific Crest Hat!
                    </Paragraph>
                    <Paragraph>
                        <Image
                            height="40vh"
                            width="60vh"
                            preview={false}
                            src={hatpicture}/>
                    </Paragraph>
                    <Paragraph>
                        Click the button below to download the Pacific Crest Hat Pattern as a PDF!
                    </Paragraph>
                    <Button
                        target="_blank"
                        size="large"
                        href={fileUrl}>
                        Download PCT Hat Pattern (as a PDF)!
                    </Button>
                    <Paragraph>
                        <Text type="danger">{fileError}</Text>
                    </Paragraph>
                </div>
            </div>
        </ConfigProvider>
        <Modal
            title="Contact Information"
            open={modal}
            onCancel={handleCancel}
            footer={[
                <Button type="primary" key="back" onClick={handleCancel}>
                    Ok
                </Button>]}>
            <Paragraph>
                You can reach Katharine via email at kekerr@cs.ubc.ca.
            </Paragraph>
            <Paragraph>
                Katharine can answer any questions you have
                regarding the Pacific Crest Hat Pattern or the study.
            </Paragraph>
            <Paragraph>
                In addition, the Consent Form of the study, which is the first page of the study, contains additional contact information.
            </Paragraph>
        </Modal>
    </>;

}